const GOOGLE_SCRIPT_URL =
  'https://script.google.com/a/macros/fenado.ai/s/AKfycbw_05-enIPAUG-4ILKq_hh0xNsZB8dgoUeY12zfeRYm2rbdjWqxdga6B9-LULP4LVr7/exec';

export interface MessageData {
  name: string;
  email: string;
  message: string;
}

export class MessageService {
  static async sendMessage(data: MessageData) {
    try {
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      return { success: true };
    } catch (error) {
      console.error('Error sending message:', error);
      throw new Error('Failed to send message. Please try again later.');
    }
  }
} 